import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import SocialIcons from "./components/SocialIcons";
import Preloader from "./components/Preloader";
import DarkModeToggle from "./components/DarkModeToggle";


import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Cars from "./pages/Cars";
import Pricing from "./pages/Pricing";
import Reviews from "./pages/Reviews";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import BookNow from "./pages/BookNow";
import ThankYou from "./pages/ThankYou";

export default function App() {
  return (
    <Router>
      <Preloader />
      <Navbar />
      <DarkModeToggle />
      <SocialIcons />
      <div className="pt-20">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/cars" element={<Cars />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/book" element={<BookNow />} />
          <Route path="/thank-you" element={<ThankYou />} />
        </Routes>
      </div>
      <Footer />
    </Router>
  );
}